import readingTime from 'reading-time'

function estimateReadingTime(content: string): string {
  return readingTime(content).text
}

export default estimateReadingTime
